export const isPriceInRange = (
  basePrice: number,
  itemPrice: number
): boolean => {
  const diff = basePrice * 0.1;
  return (
    itemPrice <= Math.ceil(basePrice + diff) &&
    itemPrice >= Math.floor(basePrice - diff)
  );
};
